module.exports = __webpack_public_path__ + "static/media/img-boxfit-product-2.5e64d9f8.png";